import { CollisionType, Sprite, Vector } from "excalibur";
import { Actor, Color, vec } from 'excalibur';
import { Resources } from "../resources";
import { collision_groups } from "../scenes/level-one/collision_groups";
import { Enemy } from "./enemies/enemy";
import { Tower } from "./towers/tower";

export class Bullet extends Actor 
{   
  public speed: number = 200
  public damage: number = 1
  public shark: Enemy

  onInitialize() {
    this.on("precollision", (event) => {
        if (event.other instanceof Enemy) {
            event.other.takeDamage(this.damage)
            this.kill()
        }
        
        //this.shoot(lilRed)
    })

    this.graphics.use(new Sprite({
      image: Resources.bullet,
      destSize: {
        width: 50,
        height: 50
      }
    }))

    const difference = this.shark.pos.sub(this.pos);

    const direction = difference.toAngle();

    if (!isNaN(direction)) {
      this.rotation = direction + Math.PI / 2;
    }

    const scale = 0.5 + this.damage / 5;

    this.scale = new Vector(scale, scale);
}

  constructor (initialX, initialY, damageIn, target) 
  {
    super({
        x: initialX,
        y: initialY,
        radius: 1,
        color: Color.Black,
        collisionGroup: collision_groups.bulletGroup,
      })
    this.damage = damageIn
    this.shark = target
    collisionType: CollisionType.Passive
  }

  follow()
  {
     if(this.shark.isKilled()){
      this.kill()
      return
     }   
    let distanceX = this.shark.pos.x - this.pos.x
    let distanceY = this.shark.pos.y - this.pos.y

    const difference = this.shark.pos.sub(this.pos);

    const direction = difference.toAngle();

    if (!isNaN(direction)) {
      this.rotation = direction + Math.PI / 2;
    }

    // if(distanceX + distanceY <= 2)
    // {
    //   this.kill()
    // }
    let tangent = Math.sqrt(distanceX * distanceX + distanceY * distanceY)
    let ratio = this.speed / tangent
    this.vel = new Vector(ratio * distanceX, ratio * distanceY)
  }
  
  public onPostUpdate(engine: ex.Engine, delta: number) 
  {
    this.follow()
  } 
}